module.exports = __webpack_public_path__ + "img/Speaker=Laila Albalkhi.6e443714.png";